var typeStyleToHtmlTag = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle: 'div',
  body1: 'div',
  body2: 'div',
  caption: 'span',
  overline: 'span',
  button: 'span',
  display1: 'div',
  display2: 'div',
  display3: 'div',
  display4: 'div',
  display5: 'div',
  display6: 'div'
};
export var getHTMLTag = function getHTMLTag(variant, variantType, tag) {
  if (tag) {
    return tag;
  }

  if (variantType === 'paragraph') {
    return 'p';
  }

  return typeStyleToHtmlTag[variant];
};